<template>
  <router-view></router-view>
</template>

<script>
import './assets/scss/style.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-good-table/dist/vue-good-table.css'

export default {
  name: 'app',
  beforeCreate () {
    // this.$store.dispatch('authFromStorage')
  }
}
</script>